import { useQuery } from 'react-query';
import { cacheKeys } from './cacheKeys';
import { handleRequest } from '../../redux/services/APIService';

export const useGetAppointmentStatusHistory = (
  options = { appointmentId: '' },
) => {
  return useQuery(
    cacheKeys.getAppointmentStatuses(options),
    async () => {
      if (!options?.appointmentId) return [];

      const response = await handleRequest(
        'get',
        `appointment/${options.appointmentId}/statuses`,
        true,
        null,
        options.filter,
      );

      return response.data;
    },
    {
      onError: (error) => {
        console.error(
          `${error.response?.data?.data?.resultMessage || error.message}`,
        );
      },
      ...options,
    },
  );
};
